<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title E-Mail Management

  section.modal-card-body
   ValidationObserver(ref="form")
   .generic-wrapper
      .container
        .form.w-600
          ValidationProvider(name="E-Mail Datum" rules="required" v-slot="{ errors, valid }") 
            b-field(label="E-Mail Datum" label-position="on-border"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
              v-date-picker(:columns="1" mode="dateTime" v-model="formData.inboxDate" is24hr)
                template(v-slot='{ inputValue, inputEvents }')
                  input.input(:value='inputValue' v-on='inputEvents')
          ValidationProvider(name="E-Mail Typ" rules="required" v-slot="{ errors, valid }") 
            b-field(label="E-Mail Typ" label-position="on-border"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
              b-select(v-model="formData.type")
                option(value="receive") E-Mail vom Gast
                option(value="send") E-Mail an den Gast 
          ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
            b-field(label="E-Mail Betreff" label-position="on-border"
                    :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
              b-input(v-model="formData.subject")
        .spacer.sm
        ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
          b-field(label="E-Mail Text" label-position="on-border"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
            vue-editor(v-model="formData.body" :editorOptions="editorOptions")
        
        .spacer.sm

        .tags
          span.tag.is-primary(v-for='(file, index) in formData.files' :key='index')
            | {{file.name}}
            button.delete.is-small(type='button' @click='deleteDropFile(index)')
        b-field
          b-upload(v-model='formData.files' multiple drag-drop)
            section.section
              .content.has-text-centered
                p
                  b-icon(icon='upload' size='is-large')
                p Fügen Sie E-Mail Anhänge hinzu

      
  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-primary(@click="saveEmail()") E-Mail speichern
</template>

<script>
import { DateTime } from "luxon"

export default {
  props: {
    booking: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        type: null,
        subject: null,
        body: null,
        inboxDate: new Date(),
        files: []
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  methods: {
    deleteDropFile(index) {
      this.formData.files.splice(index, 1);
    },
    saveEmail() {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        this.formData.inboxDate = DateTime.fromJSDate(this.formData.inboxDate).toISO();
        this.formData.rentObjectBookingId = this.booking.id;
        await this.$store.dispatch("emails/create", this.formData);
        this.$emit('refreshInbox');
        this.$emit('close');

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}
</style>